import React from 'react';
import Iframe from './iFrame';

const IframeContainer = () => {
  return <Iframe intOptionId='iframe' />;
};

export default IframeContainer;
